/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveRoleBranchGroupAssociationsRequest } from '../../models/remove-role-branch-group-associations-request';

export interface RemoveRoleBranchGroupAssociations$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: RemoveRoleBranchGroupAssociationsRequest
}

export function removeRoleBranchGroupAssociations(http: HttpClient, rootUrl: string, params: RemoveRoleBranchGroupAssociations$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeRoleBranchGroupAssociations.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeRoleBranchGroupAssociations.PATH = '/api/v1/users/{id}/role_branch_group_associations';
